/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,

} from '@nebular/theme';
import { LogoutComponent } from './@theme/components/auth/logout/logout.component';
import { AuthGuard } from './auth/auth-guard.service';
import { APP_BASE_HREF } from '@angular/common';
import { AuthService } from './auth/auth.service';
import { TokenInterceptor } from './auth/token.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthServiceLogin } from './@theme/components/auth/auth.service';
import { Storageservice } from './pages/services/storageservice.service';
import { DownloadService } from './pages/services/download.service';
// DEF0001789:changes begin:adding for hash @swati #21-Nov-2020
import  {HashLocationStrategy, LocationStrategy } from '@angular/common';
// DEF0001789:changes End:adding for hash @swati #21-Nov-2020
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
];
// import { LoginModule } from './@theme/components/auth/login/login.module';
// import { LoginModule } from './@theme/components/auth/login/login.module';

@NgModule({
  declarations: [AppComponent, LogoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    // LoginModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
    httpInterceptorProviders,
    AuthGuard, 
    AuthService,
    //TokenInterceptor,//DEF0002497 commented here @Sujitha 6-May-2022
    AuthServiceLogin,
    Storageservice,
    DownloadService ,
    { provide: APP_BASE_HREF, useValue: '/' },
    // DEF0001789:changes begin:adding provide @swati #21-Nov-2020
    { provide:LocationStrategy, useClass:HashLocationStrategy}
    // DEF0001789:changes End:adding provide @swati #21-Nov-2020
  ],
})
export class AppModule {
}
